import angular from 'angular';
import template from './patient-frame.html';
import './patient-frame.scss';
import * as devices from '../../../modules/devices';
import { VideoProviderEvents } from '../../../providers/video';
import { isCheckInPhotoCaptureEnabled } from '../../../modules/settings/helpers';
class ModalPatientFrameController {
    constructor($element, VideoProviderFactory, $ngRedux) {
        this.$element = $element;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
        VideoProviderFactory.decorateScope(this);
    }
    $onInit() {
        const videoEl = this.$element[0].querySelector('video');
        videoEl.volume = 0;
        if (this.VideoProviderFactory.activeProvider.localStream) {
            videoEl.srcObject = this.VideoProviderFactory.activeProvider.localStream;
        }
        this.VideoProviderFactory.activeProvider.on(VideoProviderEvents.LocalStreamDestroyed, () => {
            videoEl.srcObject = null;
        });
        this.VideoProviderFactory.activeProvider.on(VideoProviderEvents.LocalStream, (stream) => {
            videoEl.srcObject = stream;
        });
    }
    mapStateToThis(state) {
        return {
            hasCameraAccess: devices.selectors.hasCameraAccess(state),
            hasMicrophoneAccess: devices.selectors.hasMicrophoneAccess(state),
        };
    }
    get isCheckInPhotoCaptureEnabled() {
        return isCheckInPhotoCaptureEnabled({
            room: this.room,
            institution: this.currentInstitution,
        });
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const modalPatientFrame = {
    template,
    bindings: {
        room: '<',
        currentInstitution: '<',
    },
    controller: ModalPatientFrameController,
};
export default angular
    .module('doxy.patient.modal.modalPatientFrame', [])
    // modal-patient-frame
    .component('modalPatientFrame', modalPatientFrame).name;
